module.exports = __webpack_public_path__ + "img/hr-green-pita-mini-10.fc8541b9.png";